export default "__VITE_ASSET__CPRrI2GY__"